import { useState } from "react";
import { Link } from "react-router-dom";
import { BETA_GATE_CHECKOUT } from "../config";
import { homeSection } from '../lib/marketingHome';

const INK = "#2A1E5C";
const INK2 = "#5D5A6B";
const MUTED = "#8B7E6A";
const GOLD = "#F5CB5C";
const LINE = "#E8E2D5";

export const BetaCheckoutModal = ({ open, onClose, onContinue }) => {
  if (!open) return null;
  return (
    <div
      className="fixed inset-0 z-[130] flex items-center justify-center px-5"
      style={{ background: "rgba(26,16,60,0.72)" }}
      onClick={onClose}
      data-testid="beta-checkout-modal"
    >
      <div className="w-full max-w-md rounded-3xl p-6 sm:p-7" style={{ background: "#FFFFFF" }} onClick={(e) => e.stopPropagation()}>
        <span className="inline-block px-2.5 py-0.5 rounded-full text-[10px] font-bold tracking-widest mb-3" style={{ background: GOLD, color: INK }}>
          BETA
        </span>
        <h2 className="text-2xl mb-2" style={{ fontFamily: "'Fraunces', Georgia, serif", color: INK }}>
          We're in beta 🏁
        </h2>
        <p className="text-sm leading-relaxed mb-3" style={{ color: INK2 }} data-testid="beta-modal-copy">
          Direct checkout is paused while Payday Relay is in beta. Join the beta and get{" "}
          <b style={{ color: INK }}>free beta access</b> to the Relay Calculator, your first 52-week Payday Relay
          sheet, and the full Payday Relay app while the product is being refined.
        </p>
        <p className="text-xs leading-relaxed mb-5" style={{ color: MUTED }}>
          Beta members keep the relay sheet they start during beta. When public pricing opens, beta members
          will receive founding-member pricing if they choose to continue with Payday Relay or start a fresh relay.
        </p>
        <div className="space-y-2">
          <Link
            to={homeSection('beta')}
            onClick={onClose}
            className="block w-full py-3 rounded-full font-bold text-sm text-center transition-transform hover:scale-[1.01]"
            style={{ background: GOLD, color: INK }}
            data-testid="beta-modal-join-btn"
          >
            Join the beta, get my beta code →
          </Link>
          <button
            onClick={onContinue}
            className="block w-full py-3 rounded-full font-bold text-sm border text-center"
            style={{ borderColor: LINE, color: INK, background: "#fff" }}
            data-testid="beta-modal-continue-btn"
          >
            I have a beta code, continue to checkout →
          </button>
          <button
            onClick={onClose}
            className="block w-full py-2 text-xs underline text-center"
            style={{ color: MUTED }}
            data-testid="beta-modal-dismiss-btn"
          >
            Never mind
          </button>
        </div>
      </div>
    </div>
  );
};

// Gate any buy CTA behind the beta modal. Controlled by BETA_GATE_CHECKOUT in config.js (currently OFF, links live).
export const useBetaGate = () => {
  const [pending, setPending] = useState(null);
  const openGate = (proceed) => setPending(() => proceed);
  const gateModal = (
    <BetaCheckoutModal
      open={!!pending}
      onClose={() => setPending(null)}
      onContinue={() => {
        const go = pending;
        setPending(null);
        if (go) go();
      }}
    />
  );
  return { betaMode: BETA_GATE_CHECKOUT, openGate, gateModal };
};
